import { render, staticRenderFns } from "./freightsetting.vue?vue&type=template&id=63e69e7e"
import script from "./freightsetting.vue?vue&type=script&lang=js"
export * from "./freightsetting.vue?vue&type=script&lang=js"
import style0 from "./freightsetting.vue?vue&type=style&index=0&id=63e69e7e&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e69e7e')) {
      api.createRecord('63e69e7e', component.options)
    } else {
      api.reload('63e69e7e', component.options)
    }
    module.hot.accept("./freightsetting.vue?vue&type=template&id=63e69e7e", function () {
      api.rerender('63e69e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/freightmanager/freightsetting.vue"
export default component.exports